import { MESSAGE } from '@vindr/services/constants/message.constant';
import { Form, Input } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface FormInputAreaProps {
  name: string;
  label: string;
  placeholder: string;
  rows?: number;
  rules?: any;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  noStyle?: boolean;
  formClassName?: string;
  [key: string]: unknown;
}

const FormInputArea = ({
  name,
  label,
  placeholder,
  rules,
  rows = 4,
  required,
  disabled,
  className,
  noStyle,
  formClassName,
  ...props
}: FormInputAreaProps): JSX.Element => {
  const { t } = useTranslation('Vindoc');

  const rulesMemo = useMemo(() => {
    const rulesState = [];

    if (required) {
      rulesState.push({
        required: true,
        message: t(MESSAGE.INLINE.IEM_0001),
      });
    }

    if (rules) rulesState.push(...rules);

    return rulesState;
  }, [t, required, rules]);

  return (
    <Form.Item
      name={name}
      label={t(label)}
      rules={rulesMemo}
      className={formClassName}
      noStyle={noStyle}
    >
      <Input.TextArea
        placeholder={t(placeholder)}
        rows={rows}
        disabled={disabled}
        className={className}
        {...props}
      />
    </Form.Item>
  );
};

export default FormInputArea;
